import { EEnergyEfficiencyActions, EnergyEfficiencyActions } from "@edp-store/actions/energy-efficiency.actions";
import { IEnergyEfficiencyState, initialEnergyEfficiencyState } from "@edp-store/state/energy-efficiency.state";

export function energyEfficiencyReducers(state = initialEnergyEfficiencyState, action: EnergyEfficiencyActions): IEnergyEfficiencyState {
    switch (action.type) {
        case EEnergyEfficiencyActions.SetContractEfficiency: {
            return {
                ...state,
                contractEfficiency: action.contractEfficiency,
            };
        }

        case EEnergyEfficiencyActions.SetProductServiceCardData: {
            return {
                ...state,
                productServiceCardData: action.psData,
            };
        }

        case EEnergyEfficiencyActions.SetContentCardData: {
            return {
                ...state,
                contentCardData: action.contentCardData,
            };
        }

        case EEnergyEfficiencyActions.SetComparatorEfficientHouse: {
            return {
                ...state,
                comparatorEfficientHouse: action.payload,
            };
        }

        case EEnergyEfficiencyActions.SetComparatorElectricMobility: {
            return {
                ...state,
                comparatorElectricMobility: action.payload,
            };
        }

        default: {
            return state;
        }
    }
}
